import moment from "moment";
import { FC } from "react";

type IProps = {
  icon: string;
  title: string;
  date: string;
  // link: string;
};

const InactiveContests: FC<IProps> = ({ icon, title, date }) => {
  const createDate = moment(date).format("DD.MM.YYYY");

  return (
    <>
      <div className="flex justify-start items-center mr-5 pt-4 w-full text-sm">
        <div className="flex max-w-[20.6rem]">
          <div className="max-w-[12rem] min-w-[12rem] max-h-[6.75rem] min-h-[6.75rem] flex justify-start items-center overflow-hidden rounded-md">
            <img
              className="w-full h-full object-cover"
              style={{
                filter: "brightness(80%)",
                transition: "filter 0.3s ease-in-out",
              }}
              src={icon}
              alt=""
            />
          </div>
          <div className="w-full flex flex-col pl-3 justify-center text-base">
            <div className="w-full max-h-[4rem]">
              <h3
                className="block w-full mb-1 leading-5 font-semibold text-black text-ellipsis overflow-hidden line-clamp-3 md:hover:underline cursor-pointer"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                }}
              >
                {title}
              </h3>
            </div>
            <div>
              <span className="opacity-80">{createDate}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InactiveContests;
